import { gql } from '@apollo/client'
import { GENERATION_BASIS_VIEW_FIELDS } from '@/graphql/generation-basis-queries'

export const SUGGEST_MEDIA_PROMPTS = gql`
    mutation SuggestMediaPrompts(
        $campaignId: ID!
        $mediaType: MediaPromptType!
        $draft: String
        $systemPrompt: String
        $basis: GenerationBasisInput
    ) {
        suggestMediaPrompts(
            campaignId: $campaignId
            mediaType: $mediaType
            draft: $draft
            systemPrompt: $systemPrompt
            basis: $basis
        ) {
            title
            prompt
            persona
            basis {
                ${GENERATION_BASIS_VIEW_FIELDS}
            }
        }
    }
`

export const SUGGEST_LICENSE_KEYWORDS = gql`
    mutation SuggestLicenseKeywords(
        $campaignId: ID
        $license: LicenseDraftInput
        $exclude: [String!]
        $systemPrompt: String
    ) {
        suggestLicenseKeywords(
            campaignId: $campaignId
            license: $license
            exclude: $exclude
            systemPrompt: $systemPrompt
        )
    }
`

export const SUGGEST_LICENSE_TEXT = gql`
    mutation SuggestLicenseText(
        $campaignId: ID
        $license: LicenseDraftInput
        $field: LicenseTextField!
        $draft: String
        $systemPrompt: String
    ) {
        suggestLicenseText(
            campaignId: $campaignId
            license: $license
            field: $field
            draft: $draft
            systemPrompt: $systemPrompt
        )
    }
`

const SUGGESTION_SYSTEM_PROMPT_FIELDS = `
    kind
    prompt
    custom
`

export const GET_SUGGESTION_SYSTEM_PROMPT = gql`
    query SuggestionSystemPrompt(
        $campaignId: ID
        $license: LicenseDraftInput
        $kind: SuggestionPromptKind!
        $draft: String
    ) {
        suggestionSystemPrompt(campaignId: $campaignId, license: $license, kind: $kind, draft: $draft) {
            ${SUGGESTION_SYSTEM_PROMPT_FIELDS}
        }
    }
`

export const UPDATE_SUGGESTION_SYSTEM_PROMPT = gql`
    mutation UpdateSuggestionSystemPrompt($campaignId: ID!, $kind: SuggestionPromptKind!, $prompt: String) {
        updateSuggestionSystemPrompt(campaignId: $campaignId, kind: $kind, prompt: $prompt) {
            ${SUGGESTION_SYSTEM_PROMPT_FIELDS}
        }
    }
`

const LICENSE_OVERVIEW_FIELDS = `
    primaryUrl
    overview
    socialUrls
    styleGuideUrl
    brandFiles {
        id
        name
        mimeType
        size
        url
    }
    logo {
        id
        name
        mimeType
        size
        url
    }
    brandProfileStatus
    complete
`

export const GET_LICENSE_OVERVIEW = gql`
    query LicenseOverview($campaignId: ID!) {
        licenseOverview(campaignId: $campaignId) {
            ${LICENSE_OVERVIEW_FIELDS}
        }
    }
`

export const UPDATE_LICENSE_OVERVIEW = gql`
    mutation UpdateLicenseOverview($campaignId: ID!, $input: LicenseOverviewInput!) {
        updateLicenseOverview(campaignId: $campaignId, input: $input) {
            ${LICENSE_OVERVIEW_FIELDS}
        }
    }
`
